module.exports = __webpack_public_path__ + "img/login-footer-title.3857c0c9.png";